var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image-upload"},[_c('div',{staticClass:"form-group upload-form"},[_c('croppa',{attrs:{"placeholder-font-size":_vm.fontSize,"file-size-limit":_vm.maxFileSize},model:{value:(_vm.iconCroppa),callback:function ($$v) {_vm.iconCroppa=$$v},expression:"iconCroppa"}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3aa41fc4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ImageUploadForm.vue
// module id = 540
// module chunks = 1